import React from 'react';
import { getPartTypeLabel } from '../utils/partTypes';

// Grey chip with an order/quote line's part type. Older "à réparer" lines predate part types but are
// repairs all the same; lines with no type show nothing.
const PartTypeChip = ({ line }) => {
  const partType = line?.partType ?? (line?.notForProcurement ? 'REPARATION' : null);
  if (!partType) return null;
  return (
    <span className="flex-shrink-0 text-[11px] font-semibold text-[#707070] bg-[#EDEDED] rounded-[12px] px-2 py-0.5">
      {getPartTypeLabel(partType)}
    </span>
  );
};

export default PartTypeChip;
